import React, { useState, useImperativeHandle, forwardRef } from "react";

import Labels from "../../../assets/labels";
import { Controller, useFormContext } from "react-hook-form";
import {
  Selector,
  Modal,
  TextLink,
  Tooltip,
  useLang
} from "@manulife/mux";
import "./style/RtgHealthStyle.css";
import Content from "../../../assets/tooltipText";
import { eProduct } from "../../../services/helpers/udmGenerator";
import { ContentWrapper } from "../../../assets/appStyledComponents";
import HealthStyleModelText from "../../../assets/healthStyleModel";
import NumberConstants from "../../../assets/appStyledComponents/numberConstant.json";

const RtgHealthStyle = forwardRef(({ fieldName }, ref) => {
  const { num200, num1280 } = NumberConstants;
  const selectedLang = useLang();
  const { control, getValues } = useFormContext(); // retrieve all hook methods
  const [isModalOpen, setModalOpen] = useState(false);

  const focusHealthStyle = () => {
    // focus on first button 
    document.getElementById(`${fieldName}-0`)?.focus();
  };

  useImperativeHandle(ref, () => ({
    focus: focusHealthStyle
  }));


  function openModal(e) {
    e.preventDefault();
    setModalOpen(true);
  }
  function closeModal() {
    setModalOpen(false);
  }

  const getHealthStyleLabelValues = () => {
    const selectedProduct = getValues("rtgSelectedProduct");
    switch (selectedProduct) {
      case eProduct.FT:
      case eProduct.FTV:
        return {
          label: Labels.healthstyle[`${selectedLang}`].label,
          options: Labels.healthstyle[`${selectedLang}`].options,
          tooltip: (
            <Tooltip
              content={
                <>
                  {Content.healthstyleTooltip[`${selectedLang}`].contentLine1}
                </>
              }
              aria-label={Content.ariaHealthstyleTooltip[`${selectedLang}`]}
              bubbleWidth={num200}
            />
          ),
        };
      case eProduct.LC:
      case eProduct.SYN:
      default:
        return {
          label: (
            <>
              {`${Labels.smokingStatus[`${selectedLang}`].label} `}
              <TextLink to=""
                onClick={openModal}
              >
                {Labels.LearnMore[`${selectedLang}`]}
              </TextLink>
              <Modal isOpen={isModalOpen} onClose={closeModal}>
                <ContentWrapper>
                  <HealthStyleModelText lang={selectedLang} />
                </ContentWrapper>
              </Modal>
            </>
          ),
          options: Labels.smokingStatus[`${selectedLang}`].options,
          tooltip: null,
        };
    }
  };


  return (
    <>
      <Controller
        control={control}
        name={fieldName}
        rules={{
          required: Labels.errors.required[`${selectedLang}`],
        }}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
        }) => (
          <Selector
            id={name}
            label={getHealthStyleLabelValues().label}
            aria-required={true}
            data-testid={name}
            values={getHealthStyleLabelValues().options}
            customStyle={{
              rootStyle: {
                width: "75%",
                media: [
                  {
                    maximum: num1280,
                    width: "100%",
                  },
                ],
              },
            }}
            tooltip={getHealthStyleLabelValues().tooltip}
            selected={value}
            onBlur={onBlur}
            onChange={onChange}
            errors={error ? [error.message] : undefined}
            callouts={false}
          />
        )}
      />
    </>
  );
});

export default RtgHealthStyle;
